<!-----ATTENTION THE SPINNER COLOR IS SET IN GLOBAL STYLE CSS------->
<mat-progress-spinner class="black-spinner" [mode]="'indeterminate'" *ngIf="loading$ |async"></mat-progress-spinner>